// src/socket.js
import { io } from 'socket.io-client';

// Use the correct URL from your Render dashboard
const SERVER_URL = import.meta.env.VITE_MP_SERVER ?? "https://frozzlers-mp-server.onrender.com"; 

const socket = io(SERVER_URL, {
  autoConnect: false // We will connect manually
} );

export default socket;
